import type { ReactNode } from "react";
import { useCallback } from "react";

import { cn } from "@src/shared/lib/utils";

import { type TourId, type TourStepId, useTourGuideStore } from "../../domain";

type RefTarget = HTMLElement;

export interface TourStepProps {
  tour: TourId;
  step: TourStepId;
  children: ReactNode;
  className?: string;
}

export function TourStep({ tour, step, children, className }: TourStepProps) {
  const registerTarget = useTourGuideStore((state) => state.registerTarget);

  const setTargetRef = useCallback(
    (target: RefTarget | null) => {
      registerTarget(tour, step, target);
    },
    [registerTarget, step, tour],
  );

  return (
    <div className={cn(className)} ref={setTargetRef}>
      {children}
    </div>
  );
}
